import { resourceClient } from '@/Core/Services/ResourceClientService'
import { UserResource } from '../Resources/UserResource'

/**
 * PATCH /services/users/{id} — change a user's password.
 *
 * Uses `resourceClient` (not `restClient`) so the URL is resolved via the
 * `UserResource.restUrl` + `:id` template, matching how the original three
 * inline ChangePasswordTab implementations called it.
 */
export const ChangePasswordTask = async (userId: string, plainPassword: string): Promise<any> => {
    return resourceClient.patch(
        UserResource,
        { json: { plainPassword } },
        { restUrlReplaceParams: { id: userId } },
    )
}
